module.exports = {"SEARCH_PLACEHOLDER":"Mencari...","SEARCH_FILTER_DEFAULT_TEXT":"Semua kampanye"}